export default __webpack_public_path__ + "static/media/spotbg2.5fccfb7a.png";